import { persistor } from '@redux/store'

export function clearUserState() {
  // store.dispatch(logOut())
  // store.dispatch(clearAccountInformation())
  // store.dispatch(clearSiteInformation())
  persistor.purge()
}
